import { gql } from '@apollo/client';

export default gql`
  query getAcquirerCodesQuery($acquirerId: String!) {
    getAcquirerCodes(acquirerId: $acquirerId) {
      code
      label
      category
    }
    getMerchantConfig {
      id
      recycle {
        codes
        acquirerId
        delay {
          type
          value
        }
        rules {
          attribute
          operator
          value
        }
        type
      }
    }
  }
`;
